var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCascading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 45c0-11.046 8.954-20 20-20h100c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20H85v30c0 8.284 6.716 15 15 15h20.63c2.22-8.626 10.051-15 19.37-15h100c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20h-15v20c0 24.853-20.147 45-45 45h-20.63c-2.22 8.626-10.051 15-19.37 15H40c-11.046 0-20-8.954-20-20v-20c0-11.046 8.954-20 20-20h100c9.319 0 17.15 6.374 19.37 15H180c8.284 0 15-6.716 15-15v-20h-55c-9.319 0-17.15-6.374-19.37-15H100c-24.853 0-45-20.147-45-45V85H40c-11.046 0-20-8.954-20-20z"
})));
export default SvgCascading;